/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_Starting_ToastInputs */



/**
* | output |
* | --- |
* | "Pre-rendering film strip frame cache" |
*
* @param {Pre_Render_Frame_Cache_Starting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_starting_toast = /** @type {((inputs?: Pre_Render_Frame_Cache_Starting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Starting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pré-génération du cache d'images du film strip")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorgerenderter Filmstreifen-Frame-Cache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cache dei fotogrammi della striscia di pellicola pre-renderizzata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительная обработка кадров кинопленки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Precargando caché de fotogramas del film strip")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预渲染胶片帧缓存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィルムストリップフレームキャッシュのプリレンダリング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्री-रेंडरिंग फिल्म स्ट्रिप फ्रेम कैश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("cache de quadros de tiras de filme de pré-renderização")
	return /** @type {LocalizedString} */ ("Pre-rendering film strip frame cache")
});